export const CAMPAIGN_NAME_MAX_LENGTH = 120;

// Letters, numbers and hyphens only, single spaces between words.
// Underscores are intentionally not allowed.
const CAMPAIGN_NAME_PATTERN = /^[A-Za-z0-9-]+(?:[ ][A-Za-z0-9-]+)*$/;

export const isCampaignNameInvalid = (campaignName: string) =>
  campaignName.length > CAMPAIGN_NAME_MAX_LENGTH ||
  (campaignName.length > 0 && !CAMPAIGN_NAME_PATTERN.test(campaignName));
